import React from 'react'
import Machines from '../features/machines'
function Machine() {
  return (
    <Machines />
  )
}

export default Machine